import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/components/home/home.component';
import { moduleGuard } from '@core/guards/module.guard';
import { edaraSetupGuard } from '@core/guards/edara-setup.guard';
import { authGuard, guestGuard } from '@core';
import { UnauthorizedComponent } from '@core/components/unauthorized/unauthorized.component';
import { SetPassCodeComponent } from '@core/components/set-pass-code/set-pass-code.component';
import { CallbackComponent } from '@core/components/callback/callback.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [authGuard]
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [authGuard]
  },
  {
    path: 'set-pass-code',
    component: SetPassCodeComponent,
    canActivate: [authGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [guestGuard]
  },
  {
    path: 'pos',
    loadChildren: () => import('./point-of-sale/point-of-sale.module').then(m => m.PointOfSaleModule),
    canActivate: [authGuard, moduleGuard, edaraSetupGuard],
    data: {
      moduleName: 'pointOfSale'
    }
  },
  {
    path: 'purchasing',
    loadChildren: () => import('./purchasing/purchasing.module').then(m => m.PurchasingModule),
    canActivate: [authGuard, moduleGuard, edaraSetupGuard],
    data: {
      moduleName: 'purchasing'
    }
  },
  {
    path: 'invoicing',
    loadChildren: () => import('./invoicing/invoicing.module').then(m => m.InvoicingModule),
    canActivate: [authGuard, moduleGuard, edaraSetupGuard],
    data: {
      moduleName: 'invoicing'
    }
  },
  {
    path: 'manufacturing',
    loadChildren: () => import('./manufacturing/manufacturing.module').then(m => m.ManufacturingModule),
    canActivate: [authGuard, moduleGuard, edaraSetupGuard],
    data: {
      moduleName: 'manufacturing'
    }
  },
  {
    path: 'fixed-assets',
    loadChildren: () => import('./fixed-assets/fixed-assets.module').then(m => m.FixedAssetsModule),
    canActivate: [authGuard, moduleGuard, edaraSetupGuard],
    data: {
      moduleName: 'fixedAssets'
    }
  },
  {
    path: 'analytics',
    loadChildren: () => import('./data-analytics/data-analytics.module').then(m => m.DataAnalyticsModule),
    canActivate: [authGuard, moduleGuard, edaraSetupGuard],
    data: {
      moduleName: 'analytics'
    }
  },
  {
    path: 'data',
    loadChildren: () => import('./data/data.module').then(m => m.DataModule),
    canActivate: [authGuard, edaraSetupGuard]
  },
  {
    path: 'system',
    loadChildren: () => import('./system/system.module').then(m => m.SystemModule),
    canActivate: [authGuard]
  },
  {
    path: 'samples',
    loadChildren: () => import('./samples/samples.module').then(m => m.SamplesModule),
    canActivate: [authGuard]
  },

  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
